import { render, staticRenderFns } from "./ElementIconPicker.vue?vue&type=template&id=0ebb3f10&scoped=true&"
import script from "./ElementIconPicker.vue?vue&type=script&lang=js&"
export * from "./ElementIconPicker.vue?vue&type=script&lang=js&"
import style0 from "./ElementIconPicker.vue?vue&type=style&index=0&id=0ebb3f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb3f10",
  null
  
)

export default component.exports